import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The homepage has no Suspense boundary, so its react-snap markup is stable.
// Schedule hydration in the next task to keep bundle evaluation and DOM
// reconciliation from becoming one long main-thread task.
if (window.location.pathname === "/" && container.hasChildNodes()) {
  window.setTimeout(() => hydrateRoot(container, app), 0);
} else {
  createRoot(container).render(app);
}
